var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vp-job-monitoring" },
    [
      !_vm.isLoadingStatusBlock
        ? _c(
            "div",
            {
              staticClass: "wrap-job-status-block",
              attrs: { id: "job-status-block" }
            },
            _vm._l(_vm.jobStatusBlock, function(item, index) {
              return _c("div", { key: index, staticClass: "d-flex" }, [
                _c(
                  "div",
                  {
                    class: [
                      "container-job-status",
                      {
                        "container-job-status-active":
                          _vm.indexBlockActive === index,
                        "mr-0": index === 2
                      }
                    ],
                    style: _vm.styleDivBlock(item),
                    on: {
                      click: function($event) {
                        _vm.changeSummaryBlock(item, index)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "item-name ellipsis" }, [
                      _vm._v(_vm._s(item.name))
                    ]),
                    _vm._v(" "),
                    _vm.load_first
                      ? _c("div", { staticClass: "item-count" }, [
                          _vm._v(_vm._s(_vm.convertCountNumber(item.count)))
                        ])
                      : _c("div", { staticClass: "item-count" }, [_vm._v("-")])
                  ]
                ),
                _vm._v(" "),
                index === 2 ? _c("div", { staticClass: "line" }) : _vm._e()
              ])
            })
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoadingStatusBlock
        ? _c(
            "div",
            { staticClass: "wrap-job-status-block-loading" },
            _vm._l(6, function(i) {
              return _c("div", {
                key: "block-" + i,
                staticClass: "container-job-status"
              })
            })
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-server-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.load_first,
              expression: "load_first"
            }
          ],
          ref: "jobMonitoringTable",
          staticClass: "jTable",
          attrs: { columns: _vm.columns, options: _vm.options },
          on: { loading: _vm.loading, loaded: _vm.loaded },
          scopedSlots: _vm._u([
            {
              key: "start_time",
              fn: function(props) {
                return _c("div", {}, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.convertDateTime(props.row.start_time)) +
                      "\n    "
                  )
                ])
              }
            },
            {
              key: "end_time",
              fn: function(props) {
                return _c("div", {}, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.convertDateTime(props.row.end_time)) +
                      "\n    "
                  )
                ])
              }
            },
            {
              key: "status",
              fn: function(props) {
                return _c("div", { staticClass: "text-capitalize" }, [
                  _c("img", {
                    staticClass: "m__r--5",
                    attrs: {
                      src: require("@/assets/log/" + props.row.status + ".png")
                    }
                  }),
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        props.row.status === "success"
                          ? "Successfully"
                          : "" + props.row.status
                      ) +
                      "\n    "
                  )
                ])
              }
            },
            {
              key: "status_message",
              fn: function(props) {
                return _vm.selectedStatus === "error" ||
                  _vm.selectedStatus === "cancel"
                  ? _c("div", { staticClass: "text-uppercase" }, [
                      _vm._v(
                        "\n      " + _vm._s(props.row.status_message) + "\n    "
                      )
                    ])
                  : _vm._e()
              }
            },
            {
              key: "runtime",
              fn: function(props) {
                return _c(
                  "div",
                  {},
                  [
                    _vm.selectedStatus === "running"
                      ? _c("j-timer", { attrs: { time: props.row.start_time } })
                      : [
                          _vm._v(
                            "\n        " +
                              _vm._s(props.row.runtime || 0) +
                              " ms\n      "
                          )
                        ]
                  ],
                  2
                )
              }
            },
            {
              key: "action",
              fn: function(props) {
                return _vm.selectedStatus === "error" ||
                  _vm.selectedStatus === "cancel"
                  ? _c(
                      "div",
                      {},
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn-retry btn-retry--table",
                            on: {
                              click: function($event) {
                                _vm.toggleModalRetryJob(
                                  true,
                                  "each",
                                  props.row.running_id
                                )
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: { src: require("@/assets/icon/retry.svg") }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Retry")])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              }
            }
          ])
        },
        [
          _c(
            "div",
            {
              staticClass: "custom-search",
              attrs: { slot: "beforeFilter" },
              slot: "beforeFilter"
            },
            [
              _c(
                "b-form",
                { attrs: { inline: "" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn-refresh mr-2",
                      on: { click: _vm.refreshJobMonitoringTable }
                    },
                    [
                      _c("i", { staticClass: "fa fa-refresh" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Refresh")])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.selectedStatus === "waiting"
                    ? _c(
                        "b-button",
                        {
                          staticClass: "btn-cancel-waiting",
                          on: {
                            click: function($event) {
                              _vm.toggleModalCancelJob(true)
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-ban" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Cancel All Waiting")])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedStatus === "cancel" ||
                  _vm.selectedStatus === "error"
                    ? _c(
                        "b-button",
                        {
                          staticClass: "btn-retry",
                          on: {
                            click: function($event) {
                              _vm.toggleModalRetryJob(true, "all")
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: { src: require("@/assets/icon/retry.svg") }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Retry All")])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      !_vm.load_first ? _c("div", [_c("jLoadingTable")], 1) : _vm._e(),
      _vm._v(" "),
      _vm.isOpenModalCancelJob
        ? _c("ModalCancelJob", {
            ref: "modalCancelJob",
            attrs: { "visprog-id": _vm.id },
            on: {
              close: _vm.toggleModalCancelJob,
              completed: _vm.refreshJobMonitoringTable
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenModalRetryJob
        ? _c("ModalRetryJob", {
            ref: "modalRetryJob",
            attrs: {
              "visprog-id": _vm.id,
              "is-retry-all": _vm.isRetryAllJob,
              "run-history-id": _vm.selectedRunHistory,
              status: _vm.selectedStatus
            },
            on: {
              close: _vm.toggleModalRetryJob,
              completed: _vm.refreshJobMonitoringTable
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("LoadingScreenJobMonitoring")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4578b35a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4578b35a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/visual-programming/jVPJobMonitoring.vue
// module id = null
// module chunks = 